import { useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import "moment/locale/ru";

import { ScheduleModal } from "../ScheduleModal/ScheduleModal.jsx";

import styles from "./ScheduleButtonMobile.module.css";

export const ScheduleButtonMobile = ({ data, student, plug, forming }) => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const isForming = location.pathname === "/schedule/forming/";
  const colorOfbutton = () => (forming ? "#d1d1d1" : data.course.module.color);

  const typeOfLesson = () => {
    switch (data.type) {
      case "compensation":
        return <>Компенсация</>;
      case "adaptation":
        return <>Адаптация</>;
      default:
        break;
    }
  };

  const PlagContent = () => {
    return (
      <div className={styles.wrapper}>
        <div
          className={styles.topLine}
          style={{ backgroundColor: "#bababa" }}
        ></div>
        <div
          className={styles.body}
          style={{
            borderColor: "#bababa",
            backgroundColor: "#f2f2f2",
          }}
        >
          <h1 className="text-center">На этой неделе нет уроков!</h1>
        </div>
      </div>
    );
  };

  if (plug) return <PlagContent />;
  return (
    <>
      <div className={styles.wrapperShadow}>
        <div
          className={styles.wrapper}
          style={{ cursor: "pointer" }}
          onClick={() => setShowModal(true)}
        >
          <div
            className={styles.topLine}
            style={{ backgroundColor: colorOfbutton() }}
          ></div>
          <div
            className={styles.body}
            style={{
              borderColor: colorOfbutton(),
              backgroundColor: colorOfbutton() + "33",
            }}
          >
            <div className="row">
              <div className={["col-6", styles.content].join(" ")}>
                <h1>{data.course.name_first}</h1>
                {data.course.name_second && (
                  <span className="d-block">{data.course.name_second}</span>
                )}
                {data.number && (
                  <span className="d-block">занятие № {data.number}</span>
                )}
                <span className="d-block">
                  Модуль: {data.course.module.name}
                </span>
              </div>
              <div className="col-6">
                <strong className="d-block">{data.time}</strong>
                <span className="d-block">{data.duration} минут</span>
                {data.room && (
                  <>
                    <span className="d-block">
                      {moment(data.date).format("D MMMM")}
                    </span>
                    <span className="d-block">
                      <i className="fa fa-map-marker"></i> кабинет {data.room}
                    </span>
                  </>
                )}
                {(isForming || forming) && (
                  <>
                    <span className="d-block">
                      Свободных мест: {data.course.max_students - data.taken}
                    </span>
                  </>
                )}
                {student && (
                  <>
                    <span className="d-block">
                      {moment(data.date).format("dddd, D MMM")}
                    </span>
                    <span className="d-block">{typeOfLesson()}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScheduleModal
        data={data}
        showModal={showModal}
        setShowModal={setShowModal}
        student={student}
        colorOfbutton={colorOfbutton}
      />
    </>
  );
};
